var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"common-employee-details-modal","title":_vm.title,"title-class":"h4 font-weight-bold","lazy":"","size":"xl","hide-footer":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }